import * as firebase from "firebase";

const config = {
  apiKey: "AIzaSyC0aMKzC6GUAo52u80iwKeH59ld3Q95U-w",
  authDomain: "react-apps-tracker.firebaseapp.com",
  projectId: "react-apps-tracker",
  storageBucket: "react-apps-tracker.appspot.com",
  messagingSenderId: "211456383926",
  appId: "1:211456383926:web:ccf94c0906c6999b80bf17"
};

firebase.initializeApp(config);

// firebase.firestore().settings(settings);

export default firebase;
